module.exports = __webpack_public_path__ + "img/empty_strat.fb839ba9.png";